import React from 'react';
import {Segmented} from "antd";
import Team from "../../models/Team";
import {AppstoreOutlined, ProfileOutlined} from "@ant-design/icons";

const TeamToggleLayout = ({orientation, setOrientation}) => {
    return (
        <div className="team-toggle-layout">
            <Segmented
                // size="large"
                value={orientation}
                onChange={setOrientation}
                options={[
                    {
                        value: Team.LAYOUTS.CARD,
                        label: (
                            <div id={Team.LAYOUTS.CARD} className="ant-segmented-item-label p-0">
                                <ProfileOutlined />
                            </div>
                        ),
                    },
                    {
                        value: Team.LAYOUTS.COLUMN,

                        label: (
                            <div id={Team.LAYOUTS.COLUMN} className="ant-segmented-item-label p-0">
                                <AppstoreOutlined />
                                <span>Card</span>
                            </div>
                        ),
                    }
                ]}
            />
            {/*<InfoTooltip key={`${Team.LAYOUTS.CARD}-tooltip`} type={"dark"}*/}
            {/*             target={Team.LAYOUTS.CARD}>*/}
            {/*    View results as card*/}
            {/*</InfoTooltip>*/}
            {/*<InfoTooltip key={`${Team.LAYOUTS.COLUMN}-tooltip`} type={"dark"}*/}
            {/*             target={Team.LAYOUTS.COLUMN}>*/}
            {/*    View results as column*/}
            {/*</InfoTooltip>*/}
        </div>
    );
};

export default TeamToggleLayout;